<template>
  <el-table-column
    prop="postal_code"
    sortable="custom"
    label="Irsz."
    min-width="100"
  >
    <template slot-scope="scope">
      {{ scope.row.postal_code }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
